import { getId } from '../../util/data';
import { Loading } from '../../util/decorators';
import { omit } from '../../util/object';
import { apiNavAdd, apiNavDelete, apiNavGet, apiNavUpdate, type Nav } from '../api';

export const isEdit = (record: unknown) => Boolean(record && (<any>record).isEdit);

export interface IDataSource extends Omit<Nav, 'content'> {
  isEdit?: boolean;
  content?: Nav['content'];
}

export class NavService {
  dataSource: IDataSource[] = [];

  dataSourceLoading = false;

  @Loading<NavService>(['dataSourceLoading'])
  async requestDataSource() {
    const { data } = await apiNavGet();
    this.dataSource = data;
  }

  add() {
    this.dataSource.unshift({ isEdit: true, id: getId(), type: 'custom' } as IDataSource);
  }

  async upsert(record: Partial<IDataSource> & { id: IDataSource['id']; }) {
    if (record.id >= 0) {
      await apiNavUpdate(record);
    } else {
      await apiNavAdd(omit(record, ['id']) as Nav);
    }
  }

  async del(id: IDataSource['id']) {
    if (id >= 0) await apiNavDelete(id);
    this.dataSource.splice(this.dataSource.findIndex(_ => _.id === id), 1);
  }

  @Loading<NavService>(['dataSourceLoading'])
  async fillContent(ids: IDataSource['id'][]) {
    await Promise.allSettled(ids.map(async id => {
      const { data } = await apiNavGet({ id });
      const record = this.dataSource.find(_ => _.id === id);
      if (record) record.content = data.content;
    }));
  }
}

export const navService = new NavService();